var Polygon = /*#__PURE__*/function () {
  function Polygon() {
    this._ = [];
  }

  var _proto = Polygon.prototype;

  _proto.moveTo = function moveTo(x, y) {
    this._.push([x, y]);
  };

  _proto.closePath = function closePath() {
    this._.push(this._[0].slice());
  };

  _proto.lineTo = function lineTo(x, y) {
    this._.push([x, y]);
  };

  _proto.value = function value() {
    return this._.length ? this._ : null;
  };

  return Polygon;
}();

export { Polygon as default };